/**
 * Mock contract (strategic) partner for «تغییر قرارداد»: open any panel page with
 * `?mock_contract=1` to see the persona on a fixed 25% contract (outside the level ladder);
 * `?mock_contract=0` or a confirmed switch ends it. Kept per tab (sessionStorage). No imports.
 */
import type { ContractRatesView } from "@mfa-aff/shared";

const KEY = "mock-contract";

/** The contract rates of the mock strategic partner: 25% on everything. */
export const CONTRACT_RATES: ContractRatesView = { linkBp: 2500, refcodeBp: 2500, codeBp: 2500, renewalBp: 2500 };

export function contractPersonaActive(): boolean {
    try {
        const q = new URLSearchParams(window.location.search).get("mock_contract");
        if (q === "1") window.sessionStorage.setItem(KEY, "1");
        if (q === "0") window.sessionStorage.removeItem(KEY);
        return window.sessionStorage.getItem(KEY) === "1";
    } catch {
        return false;
    }
}

export function endContractPersona(): void {
    try {
        window.sessionStorage.removeItem(KEY);
    } catch {
        // Storage blocked: the in-memory persona has already been switched.
    }
}
